import React from 'react';
import { Form } from 'semantic-ui-react';
// props: name (String), simpleName, value (obj), data ([{},{},...])

export default class ConfigSelects extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <Form.Field>
                <label>  {this.props.simpleName}</label>
                <Form.Select
                    name={this.props.name}
                    id={this.props.name}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    options={this.props.data}
                    search
                    fluid
                />
            </Form.Field>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DocumentTemplateConfiguration/ConfigSelect.js